import { api } from "./api";

export const SupportApi = (params) => {
  return api.post(
    "/manufacturer/support/create",
    JSON.stringify(params)
  );
};
